<template>
  <div class="card-wrapper">
    <span class="circle small" />
    <span class="circle gradient" />
    <span class="circle large gradient" />

    <div class="card">
      <div class="header">
        <div class="img-wrapper">
          <img
            :src="require('@/img/profilo.png')"
            alt="Ivan Del Fatti - profilo"
          />
        </div>

        <div class="socials">
          <a href="https://linkedin.com/in/ivandf" target="_blank">
            <svg
              width="25px"
              height="25px"
              viewBox="0 0 512 512"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              xml:space="preserve"
              xmlns:serif="http://www.serif.com/"
              style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5;"
            >
              <g transform="matrix(1.38409,0,0,1.38409,-51.3967,-69.774)">
                <circle
                  cx="222.093"
                  cy="235.37"
                  r="178.054"
                  style="fill:none;stroke:white;stroke-width:10.84px;"
                />
              </g>
              <g transform="matrix(6.60293,0,0,6.60293,90.9268,94.1961)">
                <path
                  d="M8,3.01C4.53,3.01 2.01,5.089 2.01,7.949C2.01,10.819 4.59,12.99 8,12.99C11.47,12.99 13.99,10.871 13.99,7.891C13.83,5.021 11.36,3.01 8,3.01ZM3,15C2.45,15 2,15.45 2,16L2,45C2,45.55 2.45,46 3,46L13,46C13.55,46 14,45.55 14,45L14,16C14,15.45 13.55,15 13,15L3,15ZM18,15C17.45,15 17,15.45 17,16L17,45C17,45.55 17.45,46 18,46L27,46C27.552,46 28,45.552 28,45L28,29.5C28,27.13 29.821,25.2 32.141,25.02C32.261,25 32.38,25 32.5,25C32.62,25 32.739,25 32.859,25.02C35.179,25.2 37,27.13 37,29.5L37,45C37,45.552 37.448,46 38,46L47,46C47.55,46 48,45.55 48,45L48,28C48,21.53 44.529,15 36.789,15C33.269,15 30.61,16.36 29,17.49L29,16C29,15.45 28.55,15 28,15L18,15Z"
                  style="fill-rule:nonzero;"
                />
              </g>
            </svg>
          </a>

          <a href="https://codepen.io/IvanDF" target="_blank">
            <svg
              width="25px"
              height="25px"
              viewBox="0 0 512 512"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              xml:space="preserve"
              xmlns:serif="http://www.serif.com/"
              style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5;"
            >
              <g transform="matrix(1.38409,0,0,1.38409,-51.3967,-69.774)">
                <circle
                  cx="222.093"
                  cy="235.37"
                  r="178.054"
                  style="fill:none;stroke:white;stroke-width:10.84px;"
                />
              </g>
              <g transform="matrix(7.23333,0,0,7.23333,75.1667,75.1667)">
                <path
                  d="M25,4L4,17.344L4,32.652L25,46L46,32.656L46,17.344L25,4ZM25,29.184L19.066,25.07L25,21.023L30.934,25.07L25,29.184ZM27,17.605L27,9.949L40.43,18.484L34.41,22.656L27,17.605ZM23,17.605L15.59,22.656L9.57,18.484L23,9.949L23,17.605ZM12.094,25.043L8,27.832L8,22.203L12.094,25.043ZM15.57,27.453L23,32.605L23,40.051L9.59,31.527L15.57,27.453ZM27,32.605L34.43,27.453L40.41,31.527L27,40.051L27,32.605ZM37.906,25.043L42,22.203L42,27.832L37.906,25.043Z"
                  style="fill-rule:nonzero;"
                />
              </g>
            </svg>
          </a>

          <a href="https://github.com/IvanDF" target="_blank">
            <svg
              width="25px"
              height="25px"
              viewBox="0 0 512 512"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              xml:space="preserve"
              xmlns:serif="http://www.serif.com/"
              style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5;"
            >
              <g transform="matrix(1.38409,0,0,1.38409,-51.3967,-69.774)">
                <circle
                  cx="222.093"
                  cy="235.37"
                  r="178.054"
                  style="fill:none;stroke:white;stroke-width:10.84px;"
                />
              </g>
              <g transform="matrix(6.60435,0,0,6.60435,90.8913,87.5891)">
                <path
                  d="M33,29C31.203,29 30,30.516 30,33C30,35.484 30.891,38.047 33,38C35.219,37.949 36.02,35.777 36,33C35.984,30.516 34.793,29 33,29ZM44.262,17.066C44.535,15.723 44.652,10.965 42.68,6C42.68,6 38.148,6.496 31.297,11.199C29.863,10.801 27.43,10.602 25,10.602C22.57,10.602 20.141,10.801 18.699,11.195C11.852,6.496 7.324,6 7.324,6C5.348,10.965 5.445,15.609 5.738,17.066C3.418,19.586 2,22.609 2,26.742C2,44.707 16.906,44.996 20.668,44.996C21.52,44.996 23.211,44.996 25,45C26.789,44.996 28.484,44.996 29.332,44.996C33.094,44.996 48,44.707 48,26.742C48,22.609 46.582,19.586 44.262,17.066ZM25.141,43L25,43C15.57,43 8.156,41.66 8.156,32.496C8.156,30.301 8.934,28.266 10.773,26.574C13.844,23.754 19.035,25.246 24.93,25.246L25.07,25.246C30.965,25.246 36.16,23.758 39.23,26.574C41.07,28.266 41.844,30.301 41.844,32.496C41.844,41.66 34.57,43 25.141,43ZM17,29C15.207,29 14,31.016 14,33.5C14,35.984 15.207,38 17,38C18.797,38 20,35.984 20,33.5C20,31.016 18.797,29 17,29Z"
                  style="fill-rule:nonzero;"
                />
              </g>
            </svg>
          </a>
        </div>
      </div>

      <div class="body">
        <div class="text-header">
          <p>Ivan Del Fatti</p>
          <p>Front-End Developer</p>
        </div>
        <div class="text-footer">
          <a href="mailto:delfatti_ivan@icloud.com">delfatti_ivan@icloud.com</a>
          <a href="tel:+393755332378">+39 375 533 2378</a>
        </div>
      </div>

      <div class="cta">
        <router-link :to="{ name: 'Home' }"
          >Visita il mio sito
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2 16.5L16.5 2M16.5 2V11.5M16.5 2H5.5"
              stroke="#15E8FF"
              stroke-width="3"
              stroke-linecap="round"
            />
          </svg>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Card",
};
</script>

<style lang="scss">
.card-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  overflow: hidden;

  svg {
    cursor: pointer;
    path {
      fill: white;
    }
  }

  .card {
    position: relative;
    width: 426px;
    height: 252px;
    max-width: 95%;
    margin: 0 auto;
    background: linear-gradient(
      212.24deg,
      rgba(20, 116, 191, 0.4) 10.11%,
      rgba(21, 232, 255, 0.15) 94%
    );
    box-shadow: 0px 4px 24px -1px rgba(51, 51, 51, 0.2);
    backdrop-filter: blur(15px);
    border-radius: 40px;

    @media screen and (max-width: 580px) {
      height: auto;
    }

    .header {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 10px;
      position: absolute;
      width: 170px;
      height: 170px;
      right: -50px;
      top: -50px;

      @media screen and (max-width: 580px) {
        right: auto;
        left: 50%;
        transform: translateX(-50%);
      }

      background: linear-gradient(
        212.24deg,
        rgba(20, 116, 191, 0.4) 10.11%,
        rgba(21, 232, 255, 0.15) 94%
      );
      box-shadow: 0px 4px 24px -1px rgba(51, 51, 51, 0.2);
      backdrop-filter: blur(15px);
      border-radius: 40px;

      .img-wrapper {
        width: 70%;
        margin: 0 auto;
        overflow: hidden;
        border-radius: 50%;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .socials {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        gap: 15px;
      }
    }

    .body {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: 30px;

      @media screen and (max-width: 580px) {
        text-align: center;
        padding-top: 135px;
        gap: 80px;
      }

      .text-header {
        display: flex;
        flex-direction: column;
        gap: 10px;

        p {
          &:first-child {
            font-size: 36px;
            font-family: "Josefin Slab";
            font-weight: bold;
          }
        }
      }

      .text-footer {
        display: flex;
        flex-direction: column;
        gap: 10px;
        opacity: 0.8;
        font-size: 16px;
      }
    }
  }
}

.circle {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 285px;
  height: 285px;
  background: #0168b3;
  border-radius: 50%;

  &:nth-child(1) {
    transform: translate(-115%, 15%);
  }

  &:nth-child(2) {
    transform: translate(-125%, -85%);
  }

  &:nth-child(3) {
    transform: translate(19%, -45%);
  }

  @media screen and (max-width: 580px) {
    &:nth-child(1) {
      transform: translate(-125%, 52%);
    }
  }

  &.small {
    width: 157px;
    height: 157px;
  }

  &.large {
    width: 526px;
    height: 526px;
  }

  &.gradient {
    background: linear-gradient(
      135deg,
      rgba(21, 232, 255, 0.5) 0%,
      rgba(1, 104, 179, 0.5) 100%
    );
  }
}

.cta {
  position: absolute;
  width: 100%;
  bottom: -50px;
  left: 50%;
  transform: translate(-50%, -50%);

  a {
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    color: #15e8ff;
    font-weight: bold;
  }
}
</style>
